import React from 'react';
import ReactDOM from 'react-dom';
import charWatchTrack from '../shared/CharWatchTrack';

class NumWatch extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charWatchTrack(NumWatch, 'num', 'watch');


// WEBPACK FOOTER //
// ./src/components/sections/num/NumWatch.js